import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { enrichLinkedInContact } from '../../store/Integration/index.js';

export const LinkedInIcon = () => (
  <svg width='13' height='13' viewBox='0 0 24 24' fill='currentColor' xmlns='http://www.w3.org/2000/svg'>
    <path d='M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z'/>
  </svg>
);

const EnrichLinkedInButton = ({ contactId, enrichedAt, onSuccess }) => {
  const dispatch = useDispatch();
  const [error, setError] = useState(null);
  const [done, setDone] = useState(false);
  const linkedInLogin = useSelector(state => state['Integration']['linkedInLogin']) || {};
  const isLoading = linkedInLogin['enrich']?.['loading'] === true;

  const handleEnrich = () => {
    setError(null);
    setDone(false);
    dispatch(enrichLinkedInContact(
      { contactId },
      () => {
        setDone(true);
        if (onSuccess) onSuccess();
        setTimeout(() => setDone(false), 3000);
      },
      (err) => setError(err || 'Enrichment failed')
    ));
  };

  const lastEnriched = enrichedAt
    ? new Date(enrichedAt).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })
    : null;

  return (
    <div className='li-enrich-wrapper'>
      <button
        className={`li-enrich-btn${done ? ' li-enrich-btn--done' : ''}${isLoading ? ' li-enrich-btn--loading' : ''}`}
        onClick={handleEnrich}
        disabled={isLoading || done}
      >
        <span className='li-enrich-icon'>
          {isLoading ? <span className='li-enrich-spinner' /> : done ? <i className='fa fa-check' /> : <LinkedInIcon />}
        </span>
        <span className='li-enrich-label'>
          {isLoading ? 'Enriching...' : done ? 'Enriched!' : lastEnriched ? 'Re-enrich Profile' : 'Enrich from LinkedIn'}
        </span>
      </button>
      {lastEnriched && !done && !isLoading && <p className='li-enrich-last'>Last enriched {lastEnriched}</p>}
      {error && <p className='li-enrich-error'>{error}</p>}
    </div>
  );
};

export default EnrichLinkedInButton;
